module.exports = { id: "play", url: "/build/app/img/symbols.svg#play", viewBox: "", toString: function() { return this.url; } };